<template>
  <v-responsive
    :aspect-ratio="width / height"
    :max-width="width"
    :max-height="height"
    class="pa-0 ma-0"
  >
    <v-container fluid fill-height class="grey lighten-3 pa-0">
      <!-- Этот блок показывает крутяящийсяя бублик, когда картинка грузится, 
      но из-за него почему-то карти нка прыгает в последний момент при загррузке. Поэтому его пока убрал
      <v-row v-if="loading" class="fill-height ma-0" align="center" justify="center">
        
        <v-progress-circular
          indeterminate
          :size="maxWidth / 6"
          :width="maxWidth / 48"
          color="grey lighten-5"
        ></v-progress-circular>
       
      </v-row>
      -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <img
            v-bind="attrs"
            v-on="on"
            class="white--text align-end px-0 ma-0"
            :width="width - 1"
            :height="height - 1"
            contain
            :src="getImageURLByWidthAndDensity(1)"
            :srcset="
              getImageURLByWidthAndDensity(1) +
                ' 1x,' +
                getImageURLByWidthAndDensity(2) +
                ' 2x,' +
                getImageURLByWidthAndDensity(3) +
                ' 3x,' +
                getImageURLByWidthAndDensity(4) +
                ' 4x'
            "
            :options="{ rootMargin: '1000px' }"
            @load="loading = false"
            @error="errorLoadingImage"
          />
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </v-container>
  </v-responsive>
</template>

<script>
export default {
  props: {
    filename: {
      type: String,
      required: true
    },
    s3bucket: {
      type: String,
      required: true
    },
    originalWidth: {
      type: Number,
      default: -1
    },
    originalHeight: {
      type: Number,
      default: -1
    },
    slotWidth: {
      type: Number,
      required: true
    },
    slotHeight: {
      type: Number,
      required: true
    },
    keepAspectRatio: {
      type: Boolean,
      default: true
    },
    tooltip: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: true,
      buckets: [
        'bannov-land-blog-pictures',
        'bannov-land-blog-uploads',
        'bannov-land-blog-site-images'
      ],
      filenames: [this.filename, this.filename, 'no-photo.png'],
      attempt: 0
    }
  },

  computed: {
    aspectRatio() {
      if (this.keepAspectRatio) {
        return this.originalAspectRatio
      } else {
        return this.slotAspectRatio
      }
    },
    originalAspectRatio() {
      return this.originalWidth / this.originalHeight
    },
    slotAspectRatio() {
      return this.slotWidth / this.slotHeight
    },
    width() {
      console.log('slot width:', this.slotWidth)
      if (this.originalAspectRatio > this.slotAspectRatio) {
        return this.slotWidth
      } else {
        return Math.round(this.slotHeight * this.aspectRatio)
      }
    },
    height() {
      if (this.originalAspectRatio < this.slotAspectRatio) {
        return this.slotHeight
      } else {
        return Math.round(this.slotWidth / this.aspectRatio)
      }
    }
  },

  methods: {
    getImageURLByWidthAndDensity(density) {
      const imageRequest = {
        //bucket: this.buckets[this.attempt],
        //key: this.filenames[this.attempt],
        bucket: this.s3bucket,
        key: this.filename,
        edits: {
          resize: {
            width: this.width * density,
            height: this.height * density,
            fit: 'cover'
          }
          //Решалась задача возвращать в Хроме не формат webp а обычный (jpeg, png,...) формат
          //Потому что если люди будут сохраняять из браузера на компьютер, то сохраненый webp у нних не будет показываться
          // Но JPEG весит в 2 раза больше WEBP, поэтому пока решил оставить WEBP, но если что, то указывать формат можно тут
          //
          //toFormat: 'jpeg'
        }
      }
      //console.log('PICTURE_REQUEST:', imageRequest)
      const imageRequestString = JSON.stringify(imageRequest)
      const url =
        'https://dn3gl0edve2ea.cloudfront.net/' + btoa(imageRequestString)
      //console.log('PICTURE_REQUEST:', imageRequestString)
      return url
    },
    errorLoadingImage() {
      if (this.attempt < this.buckets.length - 1) {
        this.attempt++
      }
    },
    pictureClickHandler() {
      this.$emit('click')
      return false
    }
  }
}
</script>

<style></style>
